import React from 'react';
import PropTypes from 'prop-types';

import { getParams } from '../utils';

import FullWidthWrapper from '../FullWidthWrapper';
import ListItem from '../List/ListItem';

import styles from '../links.less';


const TableList = (mainProps) => {
  const { RecordSelect, sceneId, ...props } = mainProps;
  const { canExpandWidth, canExpandWidthAndHeight } = props;

  return (
    <FullWidthWrapper
      className={styles.tableList}
      fullWidth={canExpandWidth || canExpandWidthAndHeight}
    >
      {props.items &&
        props.items.map((item) => {
          if (!item) {
            return;
          }  

          const params = getParams(item, props.controlConfig, props.remoteGroup, props.parent);

          return (
            <ListItem
              sceneId={sceneId}
              key={item.get('key')}
              item={item}
              params={params}
              apiOnly={props.apiOnly}
              editable={!props.readOnly}
              className={styles.tableListItem}
              classNameItem={styles.tableListItemData}
              onRemoveItem={() => props.onRemoveItem && props.onRemoveItem(item)}
              onRestoreItem={() => props.onRestoreItem && props.onRestoreItem(item)}
            />
          );
        })}
      {RecordSelect ? (
        <RecordSelect.type
          {...RecordSelect.props}
          additionalItems={props.additionalItems}
          wrapperClassName={styles.selectorRow}
        />
      ) : null}
    </FullWidthWrapper>
  );
};

TableList.propTypes = {
  items: PropTypes.object,
  readOnly: PropTypes.bool,
  apiOnly: PropTypes.bool,
  params: PropTypes.object,
  onClickItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
};

export default TableList;
